import type { RoleFormSchemaValues } from "../schemas/role-form.schema";

export const ROLE_FORM_DEFAULT_VALUES: RoleFormSchemaValues = {
  name: "",
  permissionIds: [],
  description: undefined,
  updatedAt: undefined,
};
